import type { NavigationCounts } from '@risksmart-app/trpc/src/types';
import type { GetAssessmentCountQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetAssessmentCountDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { COUNT_STALE_TIME_MS, createQueryHook } from 'src/utils';

import type { NavigationCountArgs } from '../navigation/navigationCounts';
import {
  navigationCountsQueryOptions,
  toAggregate,
} from '../navigation/navigationCounts';

export const useGetAssessmentCount = createQueryHook<
  NavigationCountArgs,
  NavigationCounts,
  GetAssessmentCountQuery
>({
  trpcQueryOptions: navigationCountsQueryOptions,
  mapTrpcDataToGraphQL: (data) => ({
    assessment_aggregate: { aggregate: toAggregate(data.assessment) },
  }),
  // Aggregate over a register; mutations invalidate it. See COI-882.
  trpcStaleTime: COUNT_STALE_TIME_MS,
  graphqlDocument: GetAssessmentCountDocument,
});
